export const FAT_LOSS_GOAL = 2 // kgs
export const FAT_LOSS_TOTAL_GOAL = 15

export const NEXT_BIG_EVENT = 'Vegas'
export const NEXT_BIG_EVENT_DATE = new Date(2025, 11 - 1, 28)

export const START_DATE: Date = new Date('2024-12-15')
